import useLabels from "hooks/useLabels";

function AskPaperPdfLoading() {
  const [askPaperLabels] = useLabels("ask-paper");
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="flex flex-col justify-center gap-1.5 mx-12 text-center">
        <i className="text-xl text-fg-muted icon-loader animate-spin" />
        <p className="text-center text-fg-muted base-normal max-w-100">
          {askPaperLabels["loading-pdf"]}
        </p>
      </div>
    </div>
  );
}

export default AskPaperPdfLoading;
